/* Product photo lightbox.
   The 53KB PhotoSwipe ENGINE (photoswipe.min.js) is no longer loaded up front — only the
   14.6KB lightbox controller plus this file. The engine is fetched on the first photo
   click, which is the only moment it can possibly be needed.

   Why a script injection instead of the documented `pswpModule: () => import(...)`:
   this theme ships the UMD builds, not ESM (despite the .esm.js filename — both files end
   in a UMD factory assigning globalThis.PhotoSwipe / PhotoSwipeLightbox). PhotoSwipe's
   controller resolves the option as
     "object" == typeof t ? new t.default(opts) : new t(opts)
   so a promise resolving to the bare class works exactly as well as a module namespace.

   The engine URL comes from window.PSWP_ENGINE_URL, set next to the <script> tags in the
   sections that opt into the lightbox (main-product, featured-product,
   main-product-quick-view), because asset_url is only resolvable from Liquid. */
(function() {
  var enginePromise = null;

  function loadEngine() {
    if (window.PhotoSwipe) return Promise.resolve(window.PhotoSwipe);
    if (enginePromise) return enginePromise;

    var url = window.PSWP_ENGINE_URL;
    if (!url) return Promise.reject(new Error('PSWP_ENGINE_URL is not set'));

    enginePromise = new Promise(function(resolve, reject) {
      var s = document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = function() {
        if (window.PhotoSwipe) resolve(window.PhotoSwipe);
        else reject(new Error('PhotoSwipe global missing after load'));
      };
      s.onerror = function() {
        /* let a failed fetch be retried on the next click */
        enginePromise = null;
        reject(new Error('Failed to load ' + url));
      };
      document.head.appendChild(s);
    });
    return enginePromise;
  }

  var lightbox = function() {
    if (!window.PhotoSwipeLightbox) return;

    var leftArrowSVGString = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="2"></path></svg>';
    var closeSvgString = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path></svg>';

    var instance = new PhotoSwipeLightbox({
      gallery: '.splide__gallery',
      children: '.product-media-zoom',
      bgOpacity: 1,
      showHideAnimationType: 'zoom',
      loop: true,
      counter: true,
      zoom: false,
      bgClickAction: false,
      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: leftArrowSVGString,
      closeSVG: closeSvgString,
      /* Called by the controller on open; resolving late is supported and is the whole
         point — the engine downloads only once a visitor actually clicks a photo. */
      pswpModule: loadEngine
    });
    instance.init();
  };

  document.addEventListener('DOMContentLoaded', function() {
    lightbox();
    document.addEventListener('shopify:section:load', function() { lightbox(); });
  });
})()
